document.addEventListener("DOMContentLoaded", function () {
    console.log("✅ Script de búsqueda cargado correctamente.");

    const searchIcon = document.querySelector("#search-icon");
    const searchContainer = document.querySelector(".header__search-container");
    const searchInput = document.getElementById("searchInputHeader");

    // ✅ Si no hay elementos, mostrar solo una advertencia en la consola sin generar error.
    if (!searchIcon || !searchContainer || !searchInput) {
        console.warn("⚠️ No se encontró el ícono de búsqueda, el contenedor o el input. Esto es normal en algunas páginas.");
        return;
    }

    function toggleSearch(event) {
        event.preventDefault();
        event.stopPropagation();

        searchContainer.classList.toggle("active");
        console.log(
            searchContainer.classList.contains("active") 
                ? "🟢 ABRIENDO buscador." 
                : "🔴 CERRANDO buscador."
        );
    }

    function closeSearchOnClickOutside(event) {
        if (!searchContainer.contains(event.target) && event.target !== searchIcon) {
            searchContainer.classList.remove("active");
            console.log("🔴 Clic fuera: CERRANDO buscador.");
        }
    }

    searchIcon.addEventListener("click", toggleSearch);
    document.addEventListener("click", closeSearchOnClickOutside);
});

document.addEventListener("DOMContentLoaded", function () {
    console.log("✅ Script de búsqueda optimizado cargado.");

    const searchInputs = [
        document.getElementById("searchInput"), 
        document.getElementById("searchInputHeader")
    ];

    const searchResultsContainers = [ 
        document.getElementById("searchResults"), 
        document.getElementById("searchResultsHeader")
    ];

    let searchTimeout;

    const searchSynonyms = {
        "dragon ball": ["dragonball", "dbz", "db", "goku", "vegeta", "kamehameha", "super saiyan"],
        "berserk": ["guts", "espadachín negro", "griffith", "banda del halcón", "behelit"],
        "naruto": ["shippuden", "hokage", "sasuke", "uchiha", "konoha", "ninja"],
        "one piece": ["luffy", "zoro", "mugiwara", "sombrero de paja", "sanji", "grand line"],
        "hunter x hunter": ["hxh", "gon", "killua", "hisoka", "zoldyck", "nen"],
        "attack on titan": ["shingeki no kyojin", "aot", "eren", "titán", "levi", "survey corps"],
        "death note": ["kira", "l", "ryuk", "cuaderno de la muerte", "shinigami"],
        "jojo": ["jojo's bizarre adventure", "dio", "jotaro", "stand", "za warudo", "ora ora"],
        "jujutsu kaisen": ["sukuna", "gojo", "yuji", "fushiguro", "hechicería", "jjk"],
        "pokemon": ["pikachu", "ash", "kanto", "pokébola", "charizard"],
        "super campeones": ["oliver atom", "tsubasa", "hyuga", "fútbol"],
        "matrix": ["neo", "morpheus", "trinity", "realidad virtual", "píldora roja"],
        "superman": ["clark kent", "krypton", "lex luthor", "metropolis"],
        "mario": ["super mario", "nintendo", "plomero", "bowser", "peach"]
    };

    function getMainCategory(query) {
        query = query.toLowerCase();
        for (let key in searchSynonyms) {
            if (query.includes(key) || searchSynonyms[key].includes(query)) {
                return key;
            }
        }
        return query;
    }

    searchInputs.forEach((searchInput, index) => {
        if (!searchInput) return;
        const searchResultsContainer = searchResultsContainers[index];

        searchInput.addEventListener("input", function (event) {
            event.preventDefault();
            clearTimeout(searchTimeout);

            let query = searchInput.value.trim().toLowerCase();
            if (query.length < 2) {
                if (searchResultsContainer) { 
                    searchResultsContainer.innerHTML = "";
                    searchResultsContainer.style.display = "none";
                }
                return;
            }

            let mainCategory = getMainCategory(query);

            searchTimeout = setTimeout(() => {
                fetch(`/search/suggest.json?q=${mainCategory}&resources[type]=product&resources[limit]=5`)
                    .then(response => response.json())
                    .then(data => {
                        if (!searchResultsContainer) return;

                        searchResultsContainer.innerHTML = "";
                        let products = data.resources.results.products;

                        if (products.length > 0) {
                            searchResultsContainer.style.display = "block";
                            let resultHTML = `<div class="search-header">PRODUCTOS</div><ul class="search-list">`;

                            products.forEach(product => {
                                resultHTML += `
                                    <li class="search-item">
                                        <a href="${product.url}" class="search-result-link">
                                            <div class="search-result-item">
                                                <img src="${product.featured_image.url}" class="search-result-image" alt="${product.title}">
                                                <span class="search-result-text">${product.title}</span>
                                            </div>
                                        </a>
                                    </li>
                                `;
                            });

                            resultHTML += "</ul>";
                            searchResultsContainer.innerHTML = resultHTML;
                        } else {
                            searchResultsContainer.innerHTML = `<p class="search-no-results">No se encontraron resultados.</p>`;
                            searchResultsContainer.style.display = "block";
                        }
                    })
                    .catch(error => console.error("⛔ Error en la búsqueda:", error));
            }, 500);
        });

        searchInput.addEventListener("keypress", function (event) {
            if (event.key === "Enter") {
                event.preventDefault();
                let query = searchInput.value.trim();
                let mainCategory = getMainCategory(query);

                console.log("🔎 Redirigiendo a búsqueda de:", mainCategory);
                window.location.href = `/search?q=${encodeURIComponent(mainCategory)}`;
            }
        });
    });

    document.addEventListener("click", function (event) {
        searchResultsContainers.forEach((searchResultsContainer, index) => {
            const searchInput = searchInputs[index];
            if (!searchResultsContainer || !searchInput) return;

            if (!searchResultsContainer.contains(event.target) && event.target !== searchInput) {
                searchResultsContainer.innerHTML = "";
                searchResultsContainer.style.display = "none";
            }
        });
    });
});

// Función para alternar el buscador en header
function toggleSearchBar() {
    let searchInput = document.getElementById("searchInputHeader");
    if (searchInput) {
        searchInput.classList.toggle("active");
        searchInput.focus();
    } else {
        console.warn("⚠️ No se encontró el input de búsqueda en esta página.");
    }
}
